import { render, staticRenderFns } from "./StatInspView.vue?vue&type=template&id=f6efcb66"
import script from "./StatInspView.vue?vue&type=script&lang=js"
export * from "./StatInspView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports